export const DISK_SHA_CHECK_INTERVAL = 2000;
